// src/api/user.js
import { fetchWithAuth } from "./fetchWithAuth";

const API_URL = "http://qcan-dev.smart-era.com:8001/cl/v1/";

// Получение списка пользователей для подразделения
export async function getUsersByDivision(divisionId) {
  return await fetchWithAuth(`${API_URL}users/division/${divisionId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
}

// Получение данных пользователя по его ID
export async function getUserById(userId) {
  return await fetchWithAuth(`${API_URL}user/${userId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
}

// Обновление данных пользователя
export async function updateUser(userId, { name, surname, email }) {
  return await fetchWithAuth(`${API_URL}user/${userId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name, surname, email }),
  });
}

// Удаление пользователя
export async function deleteUser(userId) {
  return await fetchWithAuth(`${API_URL}user/${userId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
}

// Отправка предложения по сбросу пароля
export async function sendPasswordOffer(userId) {
  return await fetchWithAuth(`${API_URL}user/${userId}/send-password-reset-offer`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });
}

// Отправка приглашения для регистрации
export async function sendRegistrationInvitation({ enterpriseId, divisionId, email }) {
  return await fetchWithAuth(`${API_URL}user/send-registration-invitation`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ enterpriseId, divisionId, email }),
  });
}
